import type { Dispatch, SetStateAction } from "react"

import { SimulationWrapperType } from "@/test-set/simulation-wrappers"

import { EVENTS, useEventBus } from "../event-bus"
import type {
  EditableTestCase,
  PendingChanges,
  TestSetMetadata,
} from "../model"
import { getUpdatedMetadata } from "../utils/testSetEditorContextState"
import {
  applyApiSetupToPendingChanges,
  applyTestSetSimulationWrapperConfig,
} from "../utils/testSetSimulationWrapperConfig"

export function useTestSetMetadataEvents({
  setMetadata,
  setTestCases,
  setPendingChanges,
}: {
  setMetadata: Dispatch<SetStateAction<TestSetMetadata>>
  setTestCases: Dispatch<SetStateAction<EditableTestCase[]>>
  setPendingChanges: Dispatch<SetStateAction<PendingChanges | null>>
}) {
  useEventBus(EVENTS.API_SETUP_APPLY, ({ config }) => {
    setMetadata((prev) => ({
      ...prev,
      simulationWrapperType: SimulationWrapperType.API_WRAPPER,
      simulationWrapperTopLevelConfig: config,
    }))
    setTestCases((cases) =>
      applyTestSetSimulationWrapperConfig({
        config,
        testCases: cases,
      }),
    )
    setPendingChanges((pending) =>
      applyApiSetupToPendingChanges(pending, config),
    )
  })

  useEventBus(EVENTS.METADATA_UPDATE, (updates) => {
    setMetadata((prev) => getUpdatedMetadata(prev, updates))
  })
}
